<div class="mk-card fx">
  <p class="mk-muted" *ngIf="store.loadingGroups && !store.reportGroups">Loading the sales groups&hellip;</p>

  <ng-container *ngIf="store.reportGroups">
    <ng-container *ngIf="store.usableSalesGroups.length; else noneUsable">
      <b class="fx-title">One sales group for {{ count === 1 ? 'this item' : 'all ' + count + ' items' }}</b>
      <p class="mk-muted">It becomes your default sales group, so items added later without their own group use it too.</p>
      <div class="field">
        <label [for]="idPrefix + 'sales-group'">Sales group in Sage</label>
        <select [id]="idPrefix + 'sales-group'" [disabled]="store.savingDefault" (change)="picked = +$any($event.target).value">
          <option value="" disabled [selected]="picked === null">Choose a sales group&hellip;</option>
          <option *ngFor="let g of store.usableSalesGroups" [value]="g.id" [selected]="g.id === picked">{{ g.description }}</option>
        </select>
      </div>
      <button type="button" class="btn-teal-gradient fx-use" [disabled]="picked === null || store.savingDefault" (click)="use()">
        {{ store.savingDefault ? 'Saving…' : useLabel }}
      </button>
      <button
        type="button"
        class="link-btn"
        *ngIf="store.salesItems.length"
        [attr.aria-expanded]="eachOpen"
        [attr.aria-controls]="idPrefix + 'sales-items'"
        (click)="eachOpen = !eachOpen"
      >
        Choose for each item ({{ store.salesItems.length }})
        <i class="bi fx-chev" [class.bi-chevron-up]="eachOpen" [class.bi-chevron-down]="!eachOpen" aria-hidden="true"></i>
      </button>
      <div class="fx-list" *ngIf="eachOpen" [id]="idPrefix + 'sales-items'">
        <p class="mk-muted">Each item keeps its own group, even if the default changes later.</p>
        <app-sales-group-items [store]="store" [idPrefix]="idPrefix"></app-sales-group-items>
      </div>
    </ng-container>

    <ng-template #noneUsable>
      <b class="fx-title">Sage has no sales group Aivor knows yet</b>
      <p class="mk-muted">Refresh the sales groups from Sage, then choose one here.</p>
      <button
        type="button"
        class="btn-teal-gradient fx-use"
        [disabled]="store.refreshing || !syncEnabled"
        (click)="store.refreshGroups()"
      >
        {{ store.refreshing ? 'Refreshing…' : 'Refresh sales groups from Sage' }}
      </button>
      <div class="fx-status" *ngIf="store.refreshResult">{{ store.refreshResult }}</div>
    </ng-template>
  </ng-container>

  <p class="fx-error" role="alert" *ngIf="store.error">{{ store.error }}</p>
</div>
